import httpService from '@/services/httpService';
import ApiEndpoints from '@/utils/ApiEndpoints';

export default {
    postDraftSheet (familyEditionId, sheetType, data) {
        return httpService.post(ApiEndpoints.get('sheet_drafts', { familyEditionId, sheetType }), data);
    },
    getDraftSheet (familyEditionId, sheetType, data) {
        return httpService.get(ApiEndpoints.get('sheet_drafts', { familyEditionId, sheetType }));
    },
    postSheet (familyEditionId, sheetType, data) {
        return httpService.post(ApiEndpoints.get('sheet', { familyEditionId, sheetType }), data);
    },
    getSheet (familyEditionId, sheetType, data) {
        return httpService.get(ApiEndpoints.get('sheet', { familyEditionId, sheetType }));
    },
    getResourceSheet (sheetId, editionName) {
        const name = editionName || '2020';
        return httpService.get(ApiEndpoints.get('sheet_resource', { sheetId, editionName: name }));
    },
    getPartialSheetData (familyEditionId, sheetType) {
        return httpService.get(ApiEndpoints.get('patrial_sheet_data', { familyEditionId, sheetType }));
    },
    getExclusionReasons () {
        return httpService.get(ApiEndpoints.get('turn_off_reasons_for_sheet'));
    },
    getSheetPermissions (data) {
        return httpService.get(
            ApiEndpoints.get('sheet_permissions', {
                familyEditionId: data.familyEditionId,
                type: data.type
            })
        );
    },
    sendSheetCorrectionsArea (data) {
        return httpService.put(
            ApiEndpoints.get('sheet_corrections_area', {
                familyEditionId: data.familyId,
                sheetType: data.sheetType
            }),
            { sheet_json: data.data }
        );
    },
    sendSheetCorrectionsNational (data) {
        return httpService.put(
            ApiEndpoints.get('sheet_corrections_national', {
                familyEditionId: data.familyId,
                sheetType: data.sheetType
            }),
            { sheet_json: data.data }
        );
    },
    sendSheetCorrectionsVolunteer (data) {
        return httpService.put(
            ApiEndpoints.get('sheet_corrections_volunteer', {
                familyEditionId: data.familyId,
                sheetType: data.sheetType
            }),
            { sheet_json: data.data }
        );
    }
};
